import BaseComponent from '@/components/base';
import Style from '@/components/accordion/style';

export default class Accordion extends BaseComponent {
  minusIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="2" viewBox="0 0 18 2" fill="none">
      <path d="M1 1H17" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

  plusIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M9 1V17M1 9H17" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

  arrowDownIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="34" viewBox="0 0 10 24" fill="none">
      <g clip-path="url(#clip0_6689_9017)">
        <path d="M0 5.7684L0.768397 5L5 9.28571L9.2316 5.04329L10 5.7684L5 10.8225L0 5.7684Z" fill="black" fill-opacity="0.5"></path>
      </g>
      <defs>
        <clipPath id="clip0_6689_9017">
          <rect width="24" height="10" fill="white" transform="matrix(0 1 -1 0 10 0)"></rect>
        </clipPath>
      </defs>
    </svg>`;

  arrowUpIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="34" viewBox="0 0 10 24" fill="none">
      <g clip-path="url(#clip0_6689_9070)">
        <path d="M10 10.0541L9.2316 10.8225L5 6.5368L0.768398 10.7792L0 10.0541L5 5L10 10.0541Z" fill="black" fill-opacity="0.5"></path>
      </g>
      <defs>
        <clipPath id="clip0_6689_9070">
          <rect width="24" height="10" fill="white" transform="matrix(0 1 -1 0 10 0)"></rect>
        </clipPath>
      </defs>
    </svg>`;

  afterMount() {
    this.shadowRoot.querySelectorAll('.accordion-header').forEach((header) => {
      header.addEventListener('click', () => {
        header.classList.toggle('active');
      });
    });
  }

  get theme() {
    return this.getAttribute('theme') || 'original';
  }

  get title() {
    return this.getAttribute('title');
  }

  render() {
    return `
      ${Style}
      <section class="${
        this.theme === 'product-faq' ? 'product-faq-theme' : ''
      }">
        ${this.title ? `<h3>${this.title}</h3>` : ''}
        <div class="accordion-wrapper">
          ${this.data.items.value
            .map((item) => {
              return `
            <button class="accordion-header">
              <span class="accordion-header-text">${item.header}</span>
              <span class="icon accordion-plus-icon">${
                this.theme === 'product-faq'
                  ? this.arrowDownIcon
                  : this.plusIcon
              }</span>
              <span class="icon accordion-minus-icon">${
                this.theme === 'product-faq' ? this.arrowUpIcon : this.minusIcon
              }</span>
            </button>
            <div class="accordion-body">
              <p>${item.body}</p>
            </div>`;
            })
            .join('')}
        </div>
      </section>
    `;
  }
}
